import React from 'react';

import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { Tab, Tabs } from '@mui/material';

import { DASHBOARD_TABS } from '../constants';

const DashboardTabs = ({ activeTab, onChange, isSetupGuideOpen, onSetupGuideToggle }) => (
  <>
    <Tabs
      value={activeTab}
      onChange={(_, nextTab) => onChange(nextTab)}
      className="dashboard-main-tabs dashboard-text-tabs"
      aria-label="Dashboard sections"
      TabIndicatorProps={{ className: 'dashboard-tab-indicator' }}
    >
      {DASHBOARD_TABS.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={tab.label}
          className="dashboard-text-tab"
          disableRipple
        />
      ))}
    </Tabs>
    {!isSetupGuideOpen ? (
      <button
        type="button"
        className="dashboard-setup-guide-tab-button"
        aria-controls="getting-started"
        aria-expanded="false"
        aria-label="Show setup guide"
        onClick={onSetupGuideToggle}
      >
        <CheckBoxOutlinedIcon />
        <span>Setup guide</span>
      </button>
    ) : null}
  </>
);

export default DashboardTabs;
